"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
function DNGrid(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch, DNId = _a.DNId;
    // const hasSignature = globalProjectsData[state.DNData.projectId].hasSignature ?? false
    var hasSignature = false;
    var projectsCode = state.DNData.projectsIds
        .map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
        .join(", ");
    var t = (0, react_i18next_1.useTranslation)().t;
    var warehouseName = (_c = (_b = warehousesList_1.globalWarehousesData[state.DNData.warehouseId]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
    var DNBody = [
        [
            (0, titleCell_1.TitleCell)({ title: t("dn.deliveryNoteNumber"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_d = state.DNData.DNNumber) !== null && _d !== void 0 ? _d : "",
                inputType: "text",
                path: "DNData.DNNumber",
                colSpan: 5,
                required: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("dn.projectCode"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: projectsCode,
                inputType: "text",
                colSpan: 3,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("dn.deliveryNoteDate"), colSpan: 2 }),
            (_g = (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", {
                        date: (0, getDateForCell_1.default)((_e = state === null || state === void 0 ? void 0 : state.DNData) === null || _e === void 0 ? void 0 : _e.deliveryDate, mode),
                    })
                    : (0, getDateForCell_1.default)((_f = state === null || state === void 0 ? void 0 : state.DNData) === null || _f === void 0 ? void 0 : _f.deliveryDate, mode),
                inputType: "datePicker",
                colSpan: 10,
                path: "DNData.deliveryDate",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            })) !== null && _g !== void 0 ? _g : null,
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("dn.poNo"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.DNData.PONumber,
                inputType: "text",
                colSpan: 10,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("dn.deliveryLocation"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: warehouseName,
                inputType: "text",
                colSpan: 10,
            }),
        ],
    ];
    var supplierSection = [
        [
            (0, titleCell_1.TitleCell)({ title: "Supplier Name", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_h = state.DNData.supplierName) !== null && _h !== void 0 ? _h : "",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: t("dn.consigneeName"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = state.DNData.consigneeName) !== null && _j !== void 0 ? _j : "",
                inputType: "text",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Address", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_k = state.DNData.supplierAddress) !== null && _k !== void 0 ? _k : "",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Address", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_l = state.DNData.deliveryLocation) !== null && _l !== void 0 ? _l : "",
                inputType: "text",
                colSpan: 4,
            }),
        ],
        // [
        //     ValueByMode({
        //         mode,
        //         value: state.DNData.supplierName ?? '',
        //         inputType: 'text',
        //         colSpan: 6,
        //     }),
        //     ValueByMode({
        //         mode,
        //         value: state.DNData.consigneeName ?? '',
        //         inputType: 'text',
        //         colSpan: 6,
        //     }),
        // ],
        // [
        //     ValueByMode({
        //         mode,
        //         value: state.DNData.supplierAddress ?? '',
        //         inputType: 'text',
        //         colSpan: 6,
        //     }),
        //     ValueByMode({
        //         mode,
        //         value: state.DNData.deliveryLocation,
        //         inputType: 'textInput',
        //         colSpan: 6,
        //         path: 'DNData.deliveryLocation',
        //     }),
        // ],
    ];
    var itemsHeader = [
        (0, titleCell_1.TitleCell)({ title: t("dn.itemNo"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("dn.budgetLine"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: "Requested Item Description", colSpan: 2, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: "Offered Item Description", colSpan: 4, rowSpan: 1 }),
        (0, titleCell_1.TitleCell)({ title: t("dn.unit"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("dn.quantityOrdered"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("dn.quantityReceived"), colSpan: 1, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("dn.remarks"), colSpan: 1, rowSpan: 2 }),
    ];
    var itemsBody = state.DNItems.map(function (itemDoc, idx) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var unitName = (_b = (_a = unitsList_1.globalUnitsData[itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.unitId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        // const budgetLine = globalBudgetLinesData[itemDoc?.budgetLineId]?.code;
        var budgetLinesId = itemDoc.budgetLinesIds
            .map(function (budgetLineId) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
            .join(", ");
        return [
            (0, valueByMode_1.ValueByMode)({ mode: "view", value: idx + 1, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: "view", value: budgetLinesId, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "".concat((_e = (_d = (_c = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedItem) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.productName) !== null && _e !== void 0 ? _e : "", "-").concat((_h = (_g = (_f = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedItem) === null || _f === void 0 ? void 0 : _f.description) !== null && _g !== void 0 ? _g : itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.productDescription) !== null && _h !== void 0 ? _h : ""),
                inputType: "text",
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.offeredItem,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_j = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.originCountry) !== null && _j !== void 0 ? _j : "",
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_k = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.warranty) !== null && _k !== void 0 ? _k : "",
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: (_l = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.expiryDate) !== null && _l !== void 0 ? _l : "",
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({ mode: "view", value: unitName !== null && unitName !== void 0 ? unitName : "", inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_m = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.orderedQuantity) !== null && _m !== void 0 ? _m : 0,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.receivedQuantity,
                inputType: "numberInput",
                path: "DNItems[".concat(idx, "].receivedQuantity"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_o = itemDoc === null || itemDoc === void 0 ? void 0 : itemDoc.remarks) !== null && _o !== void 0 ? _o : "",
                inputType: "textArea",
                colSpan: 1,
                path: "DNItems[".concat(idx, "].remarks"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ];
    });
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b, _c;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        var supplierCurrency = (_b = currenciesList_1.globalCurrenciesData[state.RFQsData.currencyId]) === null || _b === void 0 ? void 0 : _b.name;
        // const overallTotalInDollar =
        //     supplierCurrency === 'Euro (€)'
        //         ? state.POsData.overallTotal * state.RFQsData.exchangeRate
        //         : state.POsData.overallTotal / state.RFQsData.exchangeRate
        var overallTotalRFQInDollar = supplierCurrency === "Euro (€)"
            ? state.RFQsData.overallTotal * state.RFQsData.exchangeRate
            : state.RFQsData.overallTotal / state.RFQsData.exchangeRate;
        // console.log({ overallTotalRFQInDollar });
        // const approvalPermissions = hasProjectAndWarehousePermissionWithMinAndMax(
        //   state?.DNData?.warehouseId,
        //   state?.DNData?.projectId,
        //   [`DN${approvalType}Approval`],
        //   overallTotalRFQInDollar
        // );
        var approvalPermissions = true;
        var requiredApproval = (_c = state.approvalsData) === null || _c === void 0 ? void 0 : _c.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        var commonConditions = state.DNData.status !== "approved" &&
            state.DNData.status !== "cancelled" &&
            state.DNData.status !== "completed" &&
            state.DNData.status !== "draft" &&
            state.DNData.status !== "singedAndArchived";
        var isThereRequiredApproval = approvalType === "receivedAndCheckedBy" ? true : requiredApproval;
        // console.log({
        //   approval,
        //   approvalPermissions,
        //   commonConditions,
        //   isThereRequiredApproval,
        // });
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: "view",
                // value: globalUsersData[approval.userId]?.name,
                value: "",
                colSpan: 2,
                rowSpan: 2,
            });
        }
        else if (approvalPermissions &&
            commonConditions &&
            isThereRequiredApproval) {
            return {
                action: "Approve",
                // payload: approvalType,
                payload: {
                    approvedAt: state.approvedAtSignatureDate.toDate(),
                    approvalType: approvalType,
                },
                text: t("cba.approve"),
                confirmMessage: t("alerts.areYouSureYouWantToApproveThisDocument"),
                confirmAction: true,
                type: "button",
                colSpan: 2,
                rowSpan: 2,
            };
        }
        else {
            console.log("empty");
            return (0, emptyCell_1.emptyCell)({
                colSpan: 2,
                rowSpan: 2,
            });
        }
    };
    var donorId = (_m = projectsList_1.globalProjectsData[state.DNData.projectId]) === null || _m === void 0 ? void 0 : _m.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_o = donorsList_1.globalDonorsData[donorId]) === null || _o === void 0 ? void 0 : _o.logo, height: 50, colSpan: 4, textAlign: "center" });
    var getApproval = function (approvalType) {
        var _a;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        return approval;
    };
    var approvingDate = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
        return t("common.date", { date: date === null || date === void 0 ? void 0 : date.toDate() });
    };
    var approvingSig = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
        return sig;
    };
    var approvingUser = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var uid = approval2 === null || approval2 === void 0 ? void 0 : approval2.userId;
        return uid;
    };
    var sigMode = function (type) {
        var _a;
        var approval = (_a = state === null || state === void 0 ? void 0 : state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (approval) { return approval.approvalType == type; });
        var newMode = mode == "edit" ? "view" : approval ? "view" : "edit";
        return newMode;
    };
    var receivedAndCheckedByTitle = approvingUser("receivedAndCheckedBy")
        ? usersList_1.globalUsersData[approvingUser("receivedAndCheckedBy")].jobTitle
        : "";
    var approvedByTitle = approvingUser("approvedBy")
        ? usersList_1.globalUsersData[approvingUser("approvedBy")].jobTitle
        : "";
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({
                projectId: state.DNData.projectId,
                idaLogo: miLogo,
                title: t("dn.deliveryNoteDn"),
                colSpan: 4,
            })
        ], DNBody, true), supplierSection, true), [
            itemsHeader,
            [
                (0, titleCell_1.TitleCell)({ title: t("rfq.brand"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.originCountry"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.warranty"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.expiryDate"), colSpan: 1 }),
            ]
        ], false), itemsBody, true), [
            [
                (0, titleCell_1.TitleCell)({
                    title: t("dn.receivedAndCheckedBy"),
                    colSpan: 3,
                    rowSpan: 3,
                }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                // ValueCell({
                //   value: approvingDate("receivedAndCheckedBy") ?? "",
                //   colSpan: 2,
                //   rowSpan: 2,
                // }),
                (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("receivedAndCheckedBy"),
                    value: sigMode("receivedAndCheckedBy") === "view"
                        ? approvingDate("receivedAndCheckedBy")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                    colSpan: 2,
                    rowSpan: 2,
                }),
                approvalCell("receivedAndCheckedBy"),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("receivedAndCheckedBy"),
                    colSpan: 3,
                    rowSpan: 2,
                }),
            ],
            []
        ], false), [
            [
                (0, titleCell_1.TitleCell)({ title: t("dn.approvedBy"), colSpan: 3, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                getApproval("receivedAndCheckedBy")
                    ? (0, valueByMode_1.ValueByMode)({
                        mode: sigMode("approvedBy"),
                        value: sigMode("approvedBy") === "view"
                            ? approvingDate("approvedBy")
                            : state.approvedAtSignatureDate,
                        inputType: "datePicker",
                        path: "approvedAtSignatureDate",
                        required: state.triedSubmitting,
                        triedSubmitting: state.triedSubmitting,
                        colSpan: 2,
                        rowSpan: 2,
                    })
                    : (0, emptyCell_1.emptyCell)({ colSpan: 2, rowSpan: 2 }),
                // ValueCell({
                //   value: approvingDate("approvedBy") ?? "",
                //   colSpan: 2,
                //   rowSpan: 2,
                // }),
                approvalCell("approvedBy", "receivedAndCheckedBy"),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("approvedBy"),
                    colSpan: 3,
                    rowSpan: 2,
                }),
            ],
            []
        ], false), [
            [
                (0, titleCell_1.TitleCell)({ title: t("dn.deliveredBy"), colSpan: 3, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 3, rowSpan: 2 }),
            ],
            [],
        ], false),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: __assign({}, state.DNData), dispatch: dispatch, type: "DN", orderRef: collectionsRef_1.DNsRef.doc(DNId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: "#fff" } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
}
exports.DNGrid = DNGrid;
